import { ReactComponent as CucumberIcon } from './cucumber.svg';

export default CucumberIcon;
